import React from 'react';
import { generateGoogleMapsUrl, openGoogleMaps } from '../utils/locationUtils';

const GoogleMapsLink = ({ latitude, longitude, address, children, className = '', style = {} }) => {

    const handleMapClick = (e) => {
        e.preventDefault();
        openGoogleMaps(latitude, longitude, address);
    };

    return (
        <a 
            href={generateGoogleMapsUrl(latitude, longitude, address)}
            onClick={handleMapClick}
            className={className}
            style={{
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
                ...style
            }}
            target="_blank"
            rel="noopener noreferrer"
            title="View on Google Maps"
        >
            {children || (
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <i className="ti-location-pin"></i>
                    <span>{address || 'View Location'}</span>
                    <i className="fas fa-external-link-alt" style={{ fontSize: '10px', opacity: 0.7 }}></i>
                </span>
            )}
        </a>
    );
};

export default GoogleMapsLink;
